import ShopDetailScreen from '../../../src/screens/ShopDetailScreen';

export default function ShopDetailRoute() {
  return <ShopDetailScreen />;
}
